export enum TenantInfoKey {
    TenantId = "tenant_id",
    TenantName = "tenant_name",
    TenantAddress = "tenant_address",
    TenantSupportPhone = "tenant_support_phone",
    TenantSupportEmail = "tenant_support_email",
    TenantChequePayee = "tenant_cheque_payee",
    TenantChequeAddress = "tenant_cheque_address",
    TenantEtransferAddress = "tenant_etransfer_address",
    TenantHomepage = "tenant_homepage",
    TenantGstNumber = "tenant_gst_number",
    TenantConsignmentPhone = "tenant_consignment_phone",
    TenantConsignmentEmail = "tenant_consignment_email",
    TenantConsignmentAddress = "tenant_consignment_address",
    TenantFacebook = "tenant_facebook",
    TenantInstagram = "tenant_instagram"
  }
  